import AddPhotoAlternative from "@material-symbols/svg-500/rounded/add_photo_alternate.svg?react";
import { memo } from "react";

import { IconCreator } from "./_utils/icon-creator";

import type { SVGIconProps } from "./_utils/icon-creator";

const AddPhotoAlternativeIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: AddPhotoAlternative });
	return <Icon />;
};

export default memo(AddPhotoAlternativeIcon);
